import { UnsavedChangesProtection } from 'v5/patterns/forms/unsaved-changes/UnsavedChangesProtection';
import { Dialog, DialogContentHeadless } from 'v5/design-system/Dialog';
import type { EnterpriseWorkspace } from 'v5/api/enterprise/enterprise.api';
import { MountElementProps } from 'v5/messages/mount-element';
import { WithServices } from 'v5/platform/ts/services';
import { WithEnterpriseService } from 'v5/services/io/EnterpriseService/EnterpriseService';
import {
  TransferToWorkspaceDialogContent,
  type TransferToWorkspaceDialogContentProps
} from './TransferToWorkspaceDialogContent';

export type TransferToWorkspaceDialogProps = MountElementProps &
  WithServices<[WithEnterpriseService]> &
  Pick<
    TransferToWorkspaceDialogContentProps,
    | 'organizationId'
    | 'currentWorkspaceId'
    | 'onSubmit'
    | 'titleMessage'
    | 'descriptionMessage'
    | 'fieldWorkspaceMessage'
  >;

export function TransferToWorkspaceDialog({
  open,
  onOpenChange,
  organizationId,
  currentWorkspaceId = null,
  onSubmit,
  services,
  titleMessage,
  descriptionMessage,
  fieldWorkspaceMessage
}: TransferToWorkspaceDialogProps) {
  return (
    <UnsavedChangesProtection
      open={open}
      onOpenChange={onOpenChange}
      beforeUnloadMessage="You have unsaved changes!"
    >
      {dialogProps => (
        <Dialog {...dialogProps}>
          <DialogContentHeadless className="max-w-120">
            <TransferToWorkspaceDialogContent
              open={dialogProps.open}
              organizationId={organizationId}
              currentWorkspaceId={currentWorkspaceId}
              onSubmit={onSubmit}
              services={services}
              titleMessage={titleMessage}
              descriptionMessage={descriptionMessage}
              fieldWorkspaceMessage={fieldWorkspaceMessage}
            />
          </DialogContentHeadless>
        </Dialog>
      )}
    </UnsavedChangesProtection>
  );
}
